import React, { useContext } from 'react';
import EditorElement from '../../components/EditorElement';
import { ElementContext } from '../../context/elementContext';
import { PageSettingsContext } from '../../context/pageSettingsContext';

const EditorElementWrapper = (props) => {
  const { clickElement, toggleDragging } = useContext(ElementContext);
  const { pageSettings , setIsDragAndDropped} = useContext(PageSettingsContext);
  const onClick = props.onClick || clickElement;

  return (
    <EditorElement
      element={props.element}
      clickElement={onClick}
      toggleDragging={toggleDragging}
      pageSettings={pageSettings}
      setIsDragAndDropped={setIsDragAndDropped}
      docElementTab={props.docElementTab}
      type={props.type}
    />
  )
}

export default EditorElementWrapper;